<form class="c-modal c-modal--sm" name="vm.form" (ngSubmit)="vm.handleModalSubmit()" autocomplete="off" >
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
						<p class="c-modal__title c-text c-text--xl">{{'PreVisit.Modal_Give_Consents.Consent_Title' | translate}}</p>
				</div>
			</div>
		</div>
		<div class="c-modal__content">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<p class="c-text c-text--lg">{{'PreVisit.Modal_Give_Consents.Consent_Text_1' | translate}}</p>
				<p class="c-text c-text--lg u-ost-md">{{'PreVisit.Modal_Give_Consents.Consent_Text_2' | translate}}</p>
				<p class="c-text c-text--lg u-ost-md">{{'PreVisit.Modal_Give_Consents.Consent_Text_3' | translate}}</p>
	
				<div *ngIf="!vm.isInserterAndPatientNotServicedBySameGpOrganization">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<button id="giveConsentsButton" type="submit" class="c-button c-button--s2 c-button--fit" [disabled]="vm.processing">
								{{'PreVisit.Modal_Give_Consents.Yes' | translate}}
							</button>
							<button id="cancelGiveConsentsButton" type="button" class="c-button c-button--s6 c-button--fit u-ost-md" (click)="vm.handleModalClose()" [disabled]="vm.processing">
								{{'PreVisit.Modal_Give_Consents.No' | translate}}
							</button>
						</div>
					</div>
				</div>
				<div *ngIf="vm.isInserterAndPatientNotServicedBySameGpOrganization">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<p class="c-text c-text--s3 u-osb-xs" >
								{{'PreVisit.Modal_Give_Consents.Not_Serviced_By_Same_Gp_Organization' | translate}}
							</p>
							<button id="notSameGpOrgOkButton" type="button" class="c-button c-button--s6 c-button--fit u-ost-md" (click)="vm.handleModalClose()" [disabled]="vm.processing">
								{{'Common.Ok' | translate}}
							</button>
						</div>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing"></loader-overlay>
			</div>
		</div>
	</div>
</form>
